<template>
  <div class="reset_password_phone_num_form_wrapper">
    <!-- Start:: Form Title -->
    <!-- <div class="form_title_wrapper">
    </div> -->
    <!-- End:: Form Title -->

    <!-- Start:: Form -->
    <div class="form_wrapper">
      <form class="mt-4" @submit.prevent="validateFormInputs">
        <div class="row justify-content-center">
          <!-- Start:: Reset Type Toggle -->
          <div class="col-lg-7 mb-3">
            <div class="d-flex gap-2 align-baseline">
              <base-button
                @fireClick="resetType = 'email'"
                :styleType="
                  resetType === 'email' ? 'primary_btn' : 'outline_btn'
                "
                :btnText="$t('BUTTONS.email')"
                type="button"
                class="flex-fill"
              />
              <base-button
                @fireClick="resetType = 'phone'"
                :styleType="
                  resetType === 'phone' ? 'primary_btn' : 'outline_btn'
                "
                :btnText="$t('BUTTONS.phone')"
                type="button"
                class="flex-fill"
              />
            </div>
          </div>
          <!-- End:: Reset Type Toggle -->

          <!-- Start:: Email Input -->
          <base-input
            v-if="resetType === 'email'"
            col="7"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="resetPassPhoneNumData.email"
            required
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-phone-input
            v-if="resetType === 'phone'"
            col="7"
            v-model="resetPassPhoneNumData.mobile"
            :placeholder="$t('PLACEHOLDERS.phone')"
            @dialCode="resetPassPhoneNumData.country_code = '+' + $event"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Submit Button -->
          <div class="col-lg-7 my-5">
            <base-button
              class="mt-0 w-100"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.confirm')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button -->
        </div>
      </form>

      <!-- Start:: Login Route Wrapper -->
      <router-link to="/" class="register_route">
        <span>{{ $t("BUTTONS.haveAccount") }}</span>
        <span> {{ $t("BUTTONS.login") }}</span>
      </router-link>
      <!-- End:: Login Route Wrapper -->
    </div>
    <!-- End:: Form -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ResetPasswordEmailForm",

  data() {
    return {
      // Start:: Loader Data
      isWaitingRequest: false,
      // End:: Loader Data

      // Start:: Reset Type (email or phone)
      resetType: "email", // Default to email
      // End:: Reset Type

      // Start:: Data Collection To Send
      resetPassPhoneNumData: {
        email: null,
        mobile: null,
        country_code: "+966",
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    ...mapActions({
      setAuthenticatedUserData: "AuthenticationModule/setAuthenticatedUserData",
    }),

    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (this.resetType === "email") {
        if (!this.resetPassPhoneNumData.email) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.email"));
          return;
        }
      } else if (this.resetType === "phone") {
        if (!this.resetPassPhoneNumData.mobile) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.mobile"));
          return;
        }
        // Validate phone number (8-15 digits)
        const phoneRegex = /^\d{8,15}$/;
        if (!phoneRegex.test(this.resetPassPhoneNumData.mobile)) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.invalidMobile"));
          return;
        }
      }

      this.submitForm();
    },
    // End:: Validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data based on reset type
      if (this.resetType === "email") {
        REQUEST_DATA.append("email", this.resetPassPhoneNumData.email);
      } else if (this.resetType === "phone") {
        REQUEST_DATA.append(
          "country_code",
          this.resetPassPhoneNumData.country_code
        );
        REQUEST_DATA.append("mobile", this.resetPassPhoneNumData.mobile);
      }
      // End:: Append Request Data

      try {
        let res = await this.$axios({
          method: "POST",
          url: `auth/forget-password`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        localStorage.setItem(
          "perfermo_provider_dashboard_verification_code",
          res.data.data.code
        );
        localStorage.setItem(
          "perfermo_provider_dashboard_forget_pass_token",
          res.data.data.access_token
        );

        // Set authenticated user data
        if (this.resetType === "email") {
          this.setAuthenticatedUserData({
            email: this.resetPassPhoneNumData.email,
          });
        } else {
          this.setAuthenticatedUserData({
            mobile: this.resetPassPhoneNumData.mobile,
            country_code: this.resetPassPhoneNumData.country_code,
          });
        }

        this.clearFormInputs();
        this.$router.replace("/email-verification/reset-password");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Clear Form Inputs
    clearFormInputs() {
      this.resetPassPhoneNumData.email = null;
      this.resetPassPhoneNumData.mobile = null;
      this.resetPassPhoneNumData.country_code = "+966";
    },
    // End:: Clear Form Inputs
  },
};
</script>
